import { apiClient } from './api';

interface ReminderAgent {
  name: string;
  note: string;
  synth_id: number | null;
  synth_agent_id: number;
  default_outbound_number: string;
}

interface ReminderStep {
  id: number;
  communication_method: 'sms' | 'call';
  fallback_delay_days: number;
}

interface ReminderSettings {
  days_before_appointment: number;
  preferred_time_of_day: string;
  steps: ReminderStep[];
  message_template: string;
  default_outbound_number: string;
}

interface ReminderSettingsResponse {
  results: {
    reminder_settings: ReminderSettings | null;
    reminder_agent: ReminderAgent;
  };
  status: number;
  success: boolean;
}

export const reminderService = {
  getReminderSettings: async (): Promise<ReminderSettingsResponse> => {
    const response = await apiClient.get('/synth/agent/reminder-settings');
    return response.data;
  },

  updateReminderSettings: async (settings: ReminderSettings): Promise<void> => {
    await apiClient.put('/synth/agent/reminder-settings', settings);
  },

  sendTestReminder: async (): Promise<void> => {
    await apiClient.post('/synth/agent/test-reminder');
  }
};

export default reminderService; 